import React, { useState } from 'react';
import { Toolbar, Button, IconButton, Menu, Box, Stack } from '@mui/material';
import UserMenu from './UserMenu';
import Avatar from './Avatar';
import { StartProps } from '../Layouts/MainApp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import MenuIcon from '@mui/icons-material/Menu';
import { SidebarMenuProps } from '../Layouts/Sidebar';

export const ToggleButton = (props: SidebarMenuProps) => {
  return <IconButton onClick={props.onToggle}>
    {props.open ? <MenuOpenIcon /> : <MenuIcon />}
  </IconButton>
}

const UserNav = (props: StartProps & SidebarMenuProps) => {

  const [showsUserMenu, showUserMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState();

  const toggleUserMenu = (event) => {
    showUserMenu(!showsUserMenu);
    setAnchorEl(event.currentTarget);
  }

  return (
    <Stack direction="row" alignItems="center" spacing={2} sx={{pl: 1, mt: 1, mb: 1.5}}>
      <Button onClick={toggleUserMenu}
              size="small"
              startIcon={<Avatar size={32} user={props.user} color="primary" />}
              endIcon={props.open && <KeyboardArrowDownIcon color="secondary" />}
              disableRipple
              sx={{[`&:hover`]: { backgroundColor: "transparent !important" }}}>
        <Box className="text-white">{props.workspace.name}</Box>
      </Button>
      <UserMenu {...props}
                anchorEl={anchorEl} 
                open={showsUserMenu}
                onClose={toggleUserMenu} />
    </Stack>
  );
}

export default UserNav;